<template>
  <theme-provider id="app" :theme="theme">
    <i :is="layout">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </i>
  </theme-provider>
</template>
<script>
import SimpleWrapper from './cell/simple-wrapper'
// import ThemeProvider from './cell/theme-provider'
export default {
  name: 'App',
  components: {
    SimpleWrapper,
    // ThemeProvider,
  },
  data() {
    return {}
  },
  computed: {
    currentPath() {
      return this.$route.path
    },
    theme() {
      return 'default'
    },
    layout() {
      const { $options: { components }} = this // 已经注册到app的layout组件
      const { meta, matched: [firstMatch] } = this.$route // route携带的显示信息
      const { layoutVisible = true } = meta // route携带的显示信息
      const env = 'normal' // 项目环境
      const [nouse, path] = this.currentPath.split('/') //eslint-disable-line
      const layoutName = `${this.formatName(path)}-layout`
      const defaultLayout = 'simple-wrapper'
      const hasLayoutComponent =  Object.keys(components)
        .findIndex(key => this.formatName(components[key].name) === layoutName) >= 0
      const isLayoutNotExits = !hasLayoutComponent && !(firstMatch && firstMatch.meta.layout)

      if (env === 'normal') {
        if (isLayoutNotExits || !path || !layoutVisible) {
          return defaultLayout
        } else {
          return firstMatch ? firstMatch.meta.layout : layoutName
        }
      } else {
        return null
      }
    },
  },
  methods: {
    formatName(name) {
      const firstIndex = 0
      const deleteCount = 1
      const str = name.replace(/([A-Z])/g, '-$1').toLowerCase()
      return str.indexOf('-') === firstIndex ? str.substr(deleteCount) : str
    },
  },
}
</script>
<style lang="scss">
:global {
  html,
  body {
    height: 100%;
    overflow-y: hidden;
    overflow-x: auto;
  }
  #app {
    height: 100%;
    overflow-x: auto;
  }
  body {
    margin: 0;
    // font-size: 1rem;
    font-family: -apple-system, BlinkMacSystemFont, "avenir next", avenir,
      helvetica, "helvetica neue", Ubuntu, "segoe ui", arial, sans-serif;
  }
  .page {
    text-align: center;
  }
  code {
    background-color: #f0f0f0;
    padding: 3px 5px;
    border-radius: 2px;
  }
}
div{
   /* Scrollbar */
    ::-webkit-scrollbar {width:8px;height:8px}
    ::-webkit-scrollbar-track {-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0)}
    ::-webkit-scrollbar-track:hover {-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.4);background-color:rgba(0,0,0,0.05);-webkit-border-radius: 3px;}
    ::-webkit-scrollbar-track:active {-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.4);background-color:rgba(0,0,0,0.1);-webkit-border-radius: 3px;}
    ::-webkit-scrollbar-thumb {background-color:rgba(0,0,0,0.2);-webkit-box-shadow:inset 1px 1px 0 rgba(0,0,0,.1)}
    :hover::-webkit-scrollbar-thumb {background-color:rgba(0,0,0,0.4);-webkit-box-shadow:inset 1px 1px 0 rgba(0,0,0,.1)}
    ::-webkit-scrollbar-thumb:hover {background-color:rgba(0,0,0,0.5);-webkit-box-shadow:inset 1px 1px 0 rgba(0,0,0,.1)}
    ::-webkit-scrollbar-thumb:active {background:rgba(0,0,0,0.6)}
    ::-webkit-scrollbar-track-piece,
    ::-webkit-scrollbar-track-piece {-webkit-border-radius: 0;-webkit-border-bottom-right-radius: 3px;-webkit-border-bottom-left-radius: 3px;}
    ::-webkit-scrollbar-thumb:vertical,
    ::-webkit-scrollbar-thumb:vertical {height: 50px;background-color: rgba(0, 0, 0, 0.2);-webkit-border-radius: 3px;}
    ::-webkit-scrollbar-thumb:horizontal,
    ::-webkit-scrollbar-thumb:horizontal {width: 50px;background-color: rgba(0, 0, 0, 0.2);-webkit-border-radius: 3px;}

    .ivu-menu::-webkit-scrollbar{
        display: none;
    }
}
</style>
